<template>
  <div class="w-full md:flex">
    <div class="md:w-5/12">
      <h3 class="font-semibold md:text-xl">{{ propertyTypeTitle }}</h3>
      <p
        class="mt-1 mb-5 text-sm text-gray-500 md:mt-3 md:text-base"
        v-if="propertiesCount"
      >
        {{ propertiesCount }} properties
      </p>
    </div>

    <div>
      <a
        v-for="ad in top"
        :key="ad.id"
        :href="resolveAdUrl(ad)"
        @click.prevent="handleAdClick(ad, routeName)"
        @mouseover="handleAdHoverStart()"
        @mouseout="handleAdHoverEnd(ad)"
      >
        <img
          :src="ad.photo"
          class="md:w-[728px] w-12/12 md:h-[90px] flex px-2 mx-auto md:px-0"
          alt=""
        />
      </a>
    </div>
  </div>
  <div class="flex justify-end w-full mt-5">
    <div class="flex items-center">
      <p class="mr-1 text-sm">Sort by:</p>
      <DropDown
        height="[35px]"
        buttonLabel="Featured"
        :menu-items="propertyFilters"
        radius="lg"
        unique-identifier="filters"
        @menu-item-selected="handleMenuItemSelected"
      />
    </div>
  </div>
</template>
<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { ref, defineProps, defineEmits, onMounted } from "vue";
import { useStore } from "vuex";
import DropDown from "@/components/form-components/DropDown.vue";
import { useAds } from "@/composables/useAds";
import { useRouter } from "vue-router";
const router = useRouter();
const routeName = router.currentRoute.value.fullPath;
const {
  top,
  handleAdClick,
  handleAdHoverStart,
  handleAdHoverEnd,
  resolveAdUrl,
  loadAds,
} = useAds();

// Define props and emits
defineProps({
  propertyTypeTitle: {
    type: String,
    required: true,
  },
  propertiesCount: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["property-filter"]);

const store = useStore();

// Reactive reference for property filters
const propertyFilters = ref(store.state.propertyFilters);

// Handle menu item selected
const handleMenuItemSelected = (payload) => {
  emit("property-filter", payload);
};

onMounted(() => {
  loadAds();
});
</script>
